
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { SUPPORTED_LOCALES } from "../types";

@Component
export default class TopBar extends Vue {
  @Prop({ default: "text" }) type: string;

  @Getter("app/locale") currentLocale: keyof typeof SUPPORTED_LOCALES;

  inheritAttrs = false;

  get commonAttrs() {
    return {
      outlined: true,
      ...this.currencyOptions,
      ...this.$props,
    };
  }

  get currencyOptions() {
    return {
      locale: this.currentLocale,
      defaultValue: null,
      allowNegative: false,
    };
  }
}
